import React, { createContext, useCallback, useEffect, useReducer } from 'react';
import { useLocation } from 'react-router-dom';
import { defaultState, reducers } from './reducers';
import { Actions, HINT_DURATION, UseHintState } from './types';
import usePage from '../../hooks/use-page';

export const HintContext = createContext<any>([]);

export const HintProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer<React.Reducer<UseHintState, Actions>>(
    reducers,
    defaultState()
  );

  const [{ currentPage, noOfPages }] = usePage();
  const { pathname } = useLocation();

  let resetHintTimeout;

  useEffect(() => {
    clearTimeout(resetHintTimeout);
    dispatch({ type: 'SET_SHOW_HINT', payload: { showHint: false } });

    return () => clearTimeout(resetHintTimeout);
  }, [currentPage, noOfPages, pathname]);

  const setShowHint = useCallback(() => {
    clearTimeout(resetHintTimeout);
    dispatch({ type: 'SET_SHOW_HINT', payload: { showHint: true } });

    resetHintTimeout = setTimeout(() => {
      dispatch({ type: 'SET_SHOW_HINT', payload: { showHint: false } });
    }, HINT_DURATION);
  }, [dispatch]);

  return <HintContext.Provider value={[state, { setShowHint }]}>{children}</HintContext.Provider>;
};

export default HintProvider;
